import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapeTopSection: {
    flexDirection: "row",
    width: "100%",
    height: "100%",
  },
  arrowIconCont: {
    color: "#FF0000",
    fontSize: "6px",
    alignItems: "space-between",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "16px",
    height: "15px",
    marginTop: "-5px",
  },
  landscapeArabTopSection3: {
    height: "481px",
    overflow: "hidden",
    width: "100%",
  },
  landscapeEngTopSection3: {
    width: "474px",
    height: "80%",
    transform: "rotate(90deg)",
    marginTop: "35px",
    overflowX: "hidden",
  },
  pointingText: {
    marginBottom: "6px",
    marginTop: "-13px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument12 = (props) => {
  let { arabChunks, engChunks } = props;
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };

  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", color: "#FF0000", marginRight: "6px" }}>
          <View style={{ fontSize: "6px" }}>
            <Text style={[Styles.pointingText, { width: "40px" }]}>
              Start of text
            </Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "100%" }}>
          <View style={{ overflow: "hidden", marginLeft: "6px" }}>
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>
        <View style={{ width: "40px" }}></View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              marginRight: "6px",
              alignItems: "flex-end",
            }}
          >
            <View>
              <Image
                src="/images/rightcurvepdf_arrow.png"
                style={Styles.curveArrowIcon}
              ></Image>
            </View>
          </View>
          <View
            style={[
              Styles.landscapeTopSection,
              {
                flexDirection: "row",
              },
            ]}
          >
            <View
              style={[Styles.landscapeArabTopSection3, { marginLeft: "6px" }]}
            >
              {engChunks[1]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
          </View>
          <View style={{ width: "57px" }}></View>
        </View>
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "57px",
              marginRight: "6px",
              alignItems: "flex-end",
            }}
          >
            <View>
              <Image
                src="/images/rightpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
          <View
            style={[
              Styles.landscapeTopSection,
              { flexDirection: "row-reverse" },
            ]}
          >
            <View style={Styles.landscapeArabTopSection3}>
              {engChunks[2]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
          </View>
          <View style={{ width: "40px" }}></View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "left",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View
            style={{
              width: "40px",
              marginRight: "6px",
              alignItems: "flex-end",
            }}
          >
            <View>
              <Image
                src="/images/rightpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
          <View style={[Styles.landscapeTopSection, { flexDirection: "row" }]}>
            <View
              style={[Styles.landscapeArabTopSection3, { marginLeft: "6px" }]}
            >
              {engChunks[3]?.map((word, idx) => {
                return (
                  <Text style={{}} key={idx}>
                    {word}
                  </Text>
                );
              })}
            </View>
          </View>
          <View style={{ width: "57px", fontSize: "6px", color: "#FF0000" }}>
            <View
              style={{
                width: "40px",
                position: "absolute",
                top: "98%",
                marginLeft: "20px",
              }}
            >
              <Text style={Styles.pointingText}>End of text</Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View
          style={{
            textAlign: "right",
            width: "47%",
            flexDirection: "row",
          }}
        >
          <View style={{ width: "57px", fontSize: "6px", color: "#FF0000" }}>
            <View
              style={{
                marginLeft: "65px",
                marginTop: "-30px",
                width: "25px",
                transform: "rotate(90deg)",
              }}
            >
              <Text style={Styles.pointingText}>نهاية النص</Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
              ></Image>
            </View>
          </View>
          <View>
            <View
              style={[
                Styles.landscapeEngTopSection3,
                {
                  marginRight: "63px",
                  marginLeft: "-115px",
                  marginTop: "40px",
                },
              ]}
            >
              <View style={[{ marginTop: "6px" }]}>
                {arabicText(arabChunks[3])}
              </View>
            </View>
          </View>
          <View style={{ width: "40px" }}>
            <View
              style={{
                marginLeft: "15px",
                position: "absolute",
                top: "101%",
                right: "28px",
                transform: "rotate(90deg)",
              }}
            >
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.landscapePage} orientation="landscape">
        <View
          style={{
            textAlign: "right",
            width: "42%",
            flexDirection: "row",
          }}
        >
          <View style={{ width: "40px" }}></View>
          <View>
            <View
              style={[
                Styles.landscapeEngTopSection3,
                {
                  marginRight: "63px",
                  marginLeft: "-115px",
                  marginTop: "40px",
                },
              ]}
            >
              <View>{arabicText(arabChunks[2])}</View>
            </View>
          </View>
          <View style={{ width: "57px" }}>
            <View
              style={{
                position: "absolute",
                top: "100%",
                transform: "rotate(90deg)",
                marginLeft: "26px",
              }}
            >
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
        <View
          style={{
            textAlign: "right",
            width: "50%",
            flexDirection: "row",
          }}
        >
          <View style={{ width: "57px" }}></View>
          <View>
            <View
              style={[
                Styles.landscapeEngTopSection3,
                { marginRight: "70px", marginLeft: "-50px", marginTop: "40px" },
              ]}
            >
              <View>{arabicText(arabChunks[1])}</View>
            </View>
          </View>
          <View style={{ width: "40px" }}>
            <View
              style={{
                position: "absolute",
                top: "100%",
                marginLeft: "30px",
                transform: "rotate(90deg)",
                width: "14px",
              }}
            >
              <Image
                src="/images/leftcurvepdf_arrow.png"
                style={[Styles.curveArrowIcon]}
              ></Image>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A5" style={[Styles.portraitPage, { textAlign: "right" }]}>
        <View style={{ width: "40px" }}></View>
        <View>
          <View
            style={[
              Styles.landscapeEngTopSection3,
              {
                marginTop: "63px",
                marginLeft: "-106px",
                marginRight: "63px",
                marginBottom: "63px",
              },
            ]}
          >
            <View>{arabicText(arabChunks[0])}</View>
          </View>
        </View>
        <View style={{ width: "40px", color: "#FF0000", marginRight: "40px" }}>
          <View
            style={{
              fontSize: "6px",
              position: "absolute",
              top: "102%",
              transform: "rotate(90deg)",
            }}
          >
            <Text style={Styles.pointingText}>بداية النص</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument12;
